export function buildPayRangePickerLabel(option) {
  if (!option) return "";
  return [option.code, option.name].filter(Boolean).join(" · ");
}

export function buildNoResultsMessage(query) {
  const trimmed = (query || "").trim();
  if (!trimmed) {
    return "No published pay ranges match your search. Only published pay ranges can be subscribed to.";
  }
  return `No published pay ranges match "${trimmed}". Only published pay ranges can be subscribed to.`;
}
